import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-20 px-4 bg-cream border-y border-sage" data-id="element-141" data-mp="1o2vigsgkwt85">
      <div className="max-w-4xl mx-auto" data-id="element-142" data-mp="223y639n82bl6">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-white border border-gold/40 rounded-3xl p-8 md:p-12 text-center relative overflow-hidden shadow-sm" data-id="element-143" data-mp="222wjc7wug0nm">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-1 bg-gold-gradient" data-id="element-144" data-mp="14gz2sg20y5eb" />
          <div className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-forest text-cream-light mb-8" data-id="element-145" data-mp="1j5c2no48g8e3">
            <ShieldCheck size={48} data-id="element-146" data-mp="1ebr2bpf632bq" />
          </div>
          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6 text-ink" data-id="element-147" data-mp="qnhmr58jrat1">
            🛡️ Complete 7-Day Money-Back Guarantee
          </h2>
          <div className="space-y-6 text-lg text-charcoal max-w-2xl mx-auto" data-id="element-148" data-mp="ln28mbgfxza0">
            <p data-id="element-149" data-mp="oz03pw3z42ou">
              Open the entire 6-in-1 teaching system. Explore every bonus. Use the material
              for your most challenging lesson this week.
            </p>
            <p className="font-medium text-ink" data-id="element-150" data-mp="yqe03v0momdr">
              If you feel the material is not clear, practical, or useful for your teaching
              needs, contact us within 7 days.
            </p>
            <p className="text-forest font-bold text-xl" data-id="element-151" data-mp="61yxk7yonwjb">
              We&apos;ll refund 100% of your money. No questions. No forms. No
              complications.
            </p>
            <p className="text-sm text-charcoal mt-8" data-id="element-152" data-mp="f12g9atxu9xa">
              Because if the material doesn&apos;t deliver the value we promise, we
              don&apos;t want your money.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}